import CardSectionNotOnClick from "../design/CardSectionNotOnClick";
import CardText from "../design/CardText";
import Logo from "../design/Logo";

const Sentencetoktok = () => {
  const textArray = ["문", "장", "톡", "톡"];

  const cardSectionData1 = {
    title: "말하기 훈련",
    description: "말하기는 최고의 학습법",
    emoji: "🗣️",
    listItems: [
      "학습한 영어 단어을 문장 속에서 수준별 패턴 문장으로 학습.",
      "문장 수준에 따라 끊어 읽기, 속도 조절 따라 읽기, 영어문장 말하기 음성인식",
      "문장별 따라 읽기와 음성 인식 테스트 훈련을 통해 동시 번역이 가능한 수준으로 학습을 진행합니다.",
    ],
  };

  const cardSectionData2 = {
    title: "문장학습",
    description: "다양한 학습법을 통한 문장학습",
    emoji: "✒️",
    listItems: [
      "말하기한 문장을 채워넣기, 일부 쓰기, 다 쓰기 학습을 통해 영어문장을 수준별로 학습하여 자연스럽게 독해 능력을 성장시켜줍니다.",
      "영어문장의 채워넣기는 수준별 패턴 문장을 최대 문장 중 6개의 빈칸을 정답 순으로 문장 소리를 듣기하며 문장을 채워 넣기합니다.",
      "객관식, 주관식 문장 학습하여 선생님이 원하는 과정을 최소시간으로 최대 결과치가 나올 수 있게 학습합니다.",
    ],
  };

  return (
    <section className="bg-gray-200 dark:bg-gray-700">
      <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-24 lg:px-6">
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="mb-4 text-3xl sm:text-5xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            문장학습과 말하기 훈련 문장톡톡!
          </h2>

          <div className=" pt-10 font-bold text-gray-600 sm:text-xl dark:text-gray-400">
            준비가 되었다면?
          </div>
          <a
            href="https://chamstudyland.com/vokok/desktop/test_sentence.php"
            target="_blank"
            className="mt-3 font-bold inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-purple-600 to-purple-500 hover:bg-gradient-to-b dark:shadow-purple-900 shadow-purple-200 hover:shadow-2xl hover:shadow-purple-400 hover:-tranneutral-y-px "
          >
            문장톡톡 학습하러가기!
          </a>
        </div>
        <Logo textArray={textArray} />
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="pt-10 mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            문장톡톡이란?
          </h2>
          <p className="mb-5 text-gray-600 font-bold sm:text-xl dark:text-gray-400">
            ✿ 보카톡톡 문장 학습 종류
            <br />
            특허 받은 말하기 훈련
            <br />
            영어 단어에 따른 문장을 수준별 패턴문장으로 학습.
            <br /> 끊어읽기, 속도 조절 따라 읽기, 영어문장 말하기 음성인식
          </p>
          <p className="mb-5 text-gray-600 font-bold sm:text-xl dark:text-gray-400">
            문장 학습
            <br />
            말하기한 문장을 채워넣기, 일부 쓰기, 다쓰기를 학습을 통해 영어문장의
            독해 능력을 늘려나갑니다.
          </p>
        </div>

        <div className="space-y-8 lg:grid lg:grid-cols-3 sm:gap-6 xl:gap-10 lg:space-y-0">
          <CardSectionNotOnClick {...cardSectionData1} />
          <CardSectionNotOnClick {...cardSectionData2} />
        </div>
      </div>
    </section>
  );
};

export default Sentencetoktok;
